import React from "react";
import { Button, Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import image from "../../assets/AmberSuiteImg/AS12.jpg";
import image2 from "../../assets/AmberSuiteImg/AS13.jpg";
import HoverButton from "../HoverButton";
import { WhatsappRedirection, callRedirectionNo } from "../../api/Redirection";
import LocalPhoneIcon from "@mui/icons-material/LocalPhoneOutlined";


const AmberPrice = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // 🎨 Styles declared as objects
  const styles = {
    container: {
      width: isMobile ? "90%" : "80%",
      marginBottom: isMobile ? "40px" : "70px",
      padding: "20px",
    },
    rowFlex: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: isMobile ? "wrap" : "nowrap",
      marginTop: "20px",
    },
    headingContainer: { width: isMobile ? "100%" : "60%" },
    headingText: {
      fontFamily: "ZapfHumnst BT",
      fontSize: isMobile ? "14px" : "18px",
      fontWeight: 600,
    },
    underline: { width: "100%", height: "2px", backgroundColor: "#E4CAAE", marginTop: "5px" },
    priceContainer: {
      width: isMobile ? "100%" : "60%",
      marginTop: "10px",
      display: "flex",
      justifyContent: isMobile ? "center" : "space-between",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "10px" : "0",
    },
    priceText: { fontFamily: "Sora", fontSize: isMobile ? "16px" : "24px", fontWeight: 600 },
    subText: { fontFamily: "Sora", fontSize: "12px", fontWeight: 300, color: "#442A0B" },
    buttonsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      justifyContent: isMobile ? "center" : "flex-end",
      width: isMobile ? "100%" : "40%",
      marginTop: isMobile ? "20px" : "0",
    },
    bookButton: {
      border: "1.5px solid #442A0B",
      color: "#fff",
      borderRadius: 0,
      backgroundColor: "#442A0B",
      padding: "8px 16px",
      height: "50px",
      width: isMobile ? "100%" : "278px",
      fontWeight: "bold",
      fontSize: "16px",
      letterSpacing: "0.01em",
      "&:hover": {
        backgroundColor: "#442A0B",
      },
    },
    image: {
      maxWidth: "100%",
      display: "block",
      width: "100%",
      height: "auto",
      marginBottom: isMobile ? "10px" : "20px",
    },
    textContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      position: "relative",
    },
    heading: {
      fontFamily: "ZapfHumnst BT",
      fontSize: { xs: "16px", sm: "24px" },
      lineHeight: { xs: "19.8px", sm: "29px" },
      letterSpacing: "0.05em",
      color: "#181818",
    },
    headingunderline: {
      position: "absolute",
      bottom: -5,
      left: 0,
      width: "100%",
      height: "2px",
      backgroundColor: "#E4CAAE",
    },
    weekdayheading: {
      fontFamily: "Sora",
      fontSize: { xs: "14px", sm: "19px" },
      lineHeight: { xs: "19.8px", sm: "29px" },
      letterSpacing: "0.05em",
      color: "#442A0B",
      fontWeight: 300,
    },
    subheading: {
      fontFamily: "ZapfHumnst BT",
      fontSize: { xs: "12px", sm: "16px" },
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: "0.01em",
    },
  };

  // Handler functions for redirections
  const handleWhatsAppClick = () => {
    window.open(WhatsappRedirection, "_blank");
  };

  const handleCallClick = () => {
    window.open(callRedirectionNo, "_blank");
  };

  return (
    <>
      <Box sx={styles.container}>
        <Box sx={styles.textContainer}>
          <Typography sx={styles.heading}>EXCLUSIVE TARIFF AND PRICING</Typography>
          <Box sx={styles.headingunderline} />
        </Box>
        <Box sx={styles.rowFlex}>
          {/* Weekdays Heading (60% Width) */}
          <Box sx={styles.headingContainer}>
            <Typography sx={styles.weekdayheading}>WEEKDAYS</Typography>
            <Box sx={styles.underline} />
          </Box>

          {/* Call & Book Buttons (Only on Desktop) */}
          {!isMobile && (
            <Box sx={styles.buttonsContainer}>
              <HoverButton
                btnText={<LocalPhoneIcon sx={{ marginTop: 1 }} />}
                width="50px"
                height="50px"
                onClick={handleCallClick} // Added call handler
              />
              <Button
                disableElevation
                disableRipple
                variant="contained"
                sx={styles.bookButton}
                onClick={handleWhatsAppClick} // Added WhatsApp handler
              >
                Book
              </Button>
            </Box>
          )}
        </Box>

        {/* Weekdays Prices (Updated) */}
        <Box sx={styles.priceContainer}>
          <Box>
            <Typography sx={styles.priceText}>Rs 18,000/-</Typography>
            <Typography sx={styles.subText}>all inclusive of adults</Typography>
          </Box>
          <Box>
            <Typography sx={styles.priceText}>Rs 2,000/-</Typography>
            <Typography sx={styles.subText}>per child 5 - 10 years</Typography>
          </Box>
          <Box>
            <Typography sx={styles.priceText}>Rs 5,000/-</Typography>
            <Typography sx={styles.subText}>extra adult 10+ years</Typography>
          </Box>
        </Box>

        {/* Weekend Section */}
        <Box sx={{ ...styles.headingContainer, marginTop: "20px" }}>
          <Typography sx={styles.weekdayheading}>WEEKEND</Typography>
          <Box sx={styles.underline} />
        </Box>

        {/* Weekend Prices */}
        <Box sx={styles.priceContainer}>
          <Box>
            <Typography sx={styles.priceText}>Rs 20,000/-</Typography>
            <Typography sx={styles.subText}>all inclusive of adults</Typography>
          </Box>
          <Box>
            <Typography sx={styles.priceText}>Rs 2,500/-</Typography>
            <Typography sx={styles.subText}>per child 5 - 10 years</Typography>
          </Box>
          <Box>
            <Typography sx={styles.priceText}>Rs 6,000/-</Typography>
            <Typography sx={styles.subText}>extra adult 10+ years</Typography>
          </Box>
        </Box>
        {isMobile && (
          <Box sx={styles.buttonsContainer}>
            <HoverButton
              btnText={<LocalPhoneIcon sx={{ marginTop: 1 }} />}
              width="50px"
              height="50px"
              onClick={handleCallClick} // Added call handler
            />
            <Button
              disableElevation
              disableRipple
              variant="contained"
              sx={styles.bookButton}
              onClick={handleWhatsAppClick} // Added WhatsApp handler
            >
              Book
            </Button>
          </Box>
        )}
      </Box>

      {/* Image Section */}
      <Box component="img" src={isMobile ? image2 : image} alt="Pool" sx={styles.image} />
    </>
  );
};


export default AmberPrice;
